// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"4946afc494df76ef1e04","661":"01a2b355b40ff37fdb18","838":"67a4691508f1f4586663"}[chunkId] + ".min.js";
};